/**
 * Inflating the API's zlib-compressed bodies (Python's `zlib.compress`, which DecompressionStream
 * calls "deflate") with the browser's native decompressor. It replaced pako, whose JavaScript
 * inflate held the main thread for about 0.4 s while the Scheduling board's 1,500-job backlog
 * streamed in.
 */

/** The text of a whole zlib-compressed body. Rejects if the body does not inflate whole. */
export async function inflateText(body: ArrayBuffer): Promise<string> {
	const inflated = new Response(body).body!.pipeThrough(new DecompressionStream("deflate"));
	return new Response(inflated).text();
}

/**
 * The lines of a zlib-compressed NDJSON stream, each yielded as soon as it has fully arrived (the
 * server flushes after every line). Throws if the stream does not inflate whole, a stream cut
 * short included.
 */
export async function* inflatedLines(body: ReadableStream<Uint8Array<ArrayBuffer>>): AsyncGenerator<string> {
	const reader = body.pipeThrough(new DecompressionStream("deflate")).pipeThrough(new TextDecoderStream()).getReader();
	let buffer = "";
	try {
		while (true) {
			const { done, value } = await reader.read();
			if (done) break;
			buffer += value;
			let newline: number;
			while ((newline = buffer.indexOf("\n")) >= 0) {
				const line = buffer.slice(0, newline);
				buffer = buffer.slice(newline + 1);
				if (line.trim()) yield line;
			}
		}
	} finally {
		reader.releaseLock();
	}
}
